import { useEffect, useState, useContext } from 'react'
import { UserContext, UserContextType } from '../UserContext'
import { persistent } from '../services/LocalStorage'
import * as Constants from '../services/Constants'
import { useHistory } from 'react-router-dom'
import useAppUpdateService from '../services/appUpdateService'
import useMediaPermissionActions from '../functionalities/mediaPermissions/useMediaPermissionActions'
import { env } from '../services/EnvironmentVariables'

export default function useFirstTimeAppRender() {
    const history = useHistory()

    const { state, dispatch } = useContext(UserContext) as UserContextType

    const [showAppstartNotification, set_showAppstartNotification] = useState<boolean>(false)

    const { checkForUpdate, isUpdateAvailable, showUpdateNotification, closeUpdateNotification, runAppUpdate } =
        useAppUpdateService()

    const { loadCurrentMediaPermissions, showMediaPermissionsChecklistIfNeeded } = useMediaPermissionActions()

    useEffect(() => {
        if (persistent.getBoolean(Constants.show_welcome_page)) {
            history.push('/welcome-to-muse')
        }
    }, [])

    useEffect(() => {
        // We check for update when the profile loads. The latest version info (in _appRuntimeConstants)
        // is pulled along with the user data.
        if (!state.profile) {
            return
        }

        const isAppFirstTimeRender = persistent.getBoolean(Constants.is_first_time_app_render)
        if (isAppFirstTimeRender === false) {
            return
        }

        if (persistent.getBoolean(Constants.show_welcome_page)) {
            history.push('/welcome-to-muse')
            return
        }

        // decide whether to show the appstart notification popup
        let appstart_notifications_suppress_id = persistent.getInt(Constants.appstart_notifications_suppress_id) || 0
        console.log(`useFirstTimeAppRender: Constants.appstart_notification?.id=${Constants.appstart_notification?.id}`)
        console.log(
            `useFirstTimeAppRender: Constants.appstart_notifications_suppress_id=${appstart_notifications_suppress_id}`
        )

        if (env.IS_ELECTRON) {
            if (
                Constants.appstart_notification?.id > appstart_notifications_suppress_id ||
                env.ALWAYS_SHOW_APPSTART_NOTIFICATION
            ) {
                set_showAppstartNotification(true)
            } else {
                // app update service
                checkForUpdate()
            }
        }

        persistent.set(Constants.is_first_time_app_render, false)

        loadCurrentMediaPermissions().then(() => {
            showMediaPermissionsChecklistIfNeeded()
        })
    }, [state.profile])

    return {
        isUpdateAvailable,
        showUpdateNotification,
        showAppstartNotification,
        closeUpdateNotification,
        set_showAppstartNotification,
        runAppUpdate,
    }
}
